import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { Form, Message } from 'semantic-ui-react';

import { v4 as uuid } from 'uuid';
import moment from 'moment';
import ScrollableAnchor from 'react-scrollable-anchor';
import { Analytics } from 'aws-amplify';
import MutationNewSubscriber from '../graphql/MutationNewSubscriber';
import QueryAllSubscribers from '../graphql/QueryAllSubscribers';

class NewSubscriber extends Component {
  static defaultProps = {
    submit: () => null,
    data: { listSubscribers: { subscribers: [] } },
  };

  state = {
    subscriber: {
      email: '',
      createdAt: '',
    },
    submittedEmail: '',
    error: false,
    success: false,
  };

  handleChange(field, { target: { value } }) {
    const { subscriber } = this.state;
    subscriber[field] = value;
    this.setState({ subscriber });
  }

  handleNewSubscriber = async e => {
    e.stopPropagation();
    e.preventDefault();
    const { addSubscriber, mode, setResultsPage } = this.props;
    const { subscriber } = this.state;
    subscriber.createdAt = moment().toISOString();

    await addSubscriber(subscriber);
    this.setState({
      submittedEmail: subscriber.email,
      success: true,
      subscriber: { email: '' },
    });
    Analytics.record('Subscriber-Registered');
    if (mode === 'admin') {
      setResultsPage('0');
      setTimeout(function() {
        setResultsPage('1');
      }, 1000);
    }
  };

  render() {
    const { subscriber, submittedEmail, error, success } = this.state;
    const { mode, setResultsPage } = this.props;
    const successMessage = `We've added ${submittedEmail}. Thanks for getting \
    on board. We'll be in touch when we have more news on the launch!`;

    return (
      <ScrollableAnchor id="signup">
        <Form
          onSubmit={this.handleNewSubscriber}
          error={Boolean(error)}
          success={Boolean(success)}
        >
          <Form.Input
            fluid
            action="Subscribe"
            value={subscriber.email}
            id="email"
            onFocus={() => {
              if (mode === 'admin') {
                setResultsPage('1');
              }
            }}
            onChange={this.handleChange.bind(this, 'email')}
            label="Email address"
            placeholder="Add email address"
            type="email"
            style={{ width: '70%' }}
          />
          <Message
            success
            header="Yay! You're Subscribed"
            content={successMessage}
          />
          <Message
            error
            header="Oops! Something Went Wrong"
            content="There was a problem with your submission sorry. Please \
            check and resubmit your email, or contact us at info@tribevibe.com"
          />
        </Form>
      </ScrollableAnchor>
    );
  }
}

// Conditional options for admin mode
const updateCacheOption = {
  refetchQueries: [
    {
      query: QueryAllSubscribers,
    },
  ],
  update: (proxy, { data: { addSubscriber } }) => {
    const query = QueryAllSubscribers;
    try {
      const data = proxy.readQuery({
        query,
      });
      if (data.listSubscribers.subscribers[0].email !== addSubscriber.email) {
        data.listSubscribers.subscribers.splice(0, 0, addSubscriber);
        data.listSubscribers.subscribers.pop();
      }
      proxy.writeQuery({
        query,
        data,
      });
    } catch (error) {}
  },
};

// Create our enhancer function
const configForMutationNewSubscriber = {
  options: props => {
    return props.mode === 'admin' ? updateCacheOption : {};
  },
  props: props => ({
    addSubscriber: subscriber => {
      return props.mutate({
        variables: subscriber,
        optimisticResponse: () => ({
          addSubscriber: {
            id: uuid(),
            email: subscriber.email,
            status: 'active',
            notified: 'pending',
            createdAt: subscriber.createdAt,
            __typename: 'Subscriber',
          },
        }),
      });
    },
  }),
};

const withNewSubscriberMutation = graphql(
  MutationNewSubscriber,
  configForMutationNewSubscriber,
);

// Enhahce our component
const NewSubscriberWithData = withNewSubscriberMutation(NewSubscriber);

// Export the enhanced component
export default NewSubscriberWithData;



// WEBPACK FOOTER //
// ./src/components/NewSubscriber.js